var _path, _rect, _path2, _path3, _rect2, _rect3, _path4, _path5, _path6, _rect4, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTulip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2173 9.7817C20.2173 4.37942 24.5976 0 29.9999 0V9.7817H20.2173Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.2173,
    y: 10.1094,
    width: 9.78261,
    height: 9.7817,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2173 20.2188H29.9999C29.9999 25.621 25.6196 30.0005 20.2173 30.0005V20.2188Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1086 9.7817C10.1086 4.37942 14.489 0 19.8912 0V9.7817H10.1086Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.1086,
    y: 10.1094,
    width: 9.78261,
    height: 9.7817,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.1086,
    y: 20.2188,
    width: 9.78261,
    height: 9.7817,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1086 10.1094C15.5109 10.1094 19.8912 14.4888 19.8912 19.8911H10.1086V10.1094Z",
    fill: "#F5B416"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1086 20.2188H19.8912C19.8912 25.621 15.5109 30.0005 10.1086 30.0005V20.2188Z",
    fill: "#EF8813"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C5.40229 0 9.78261 4.37942 9.78261 9.7817H0V0Z",
    fill: "#3B91DF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 10.1094,
    width: 9.78261,
    height: 9.7817,
    fill: "#64B5C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.2188H9.78261V30.0005C4.38032 30.0005 0 25.621 0 20.2188Z",
    fill: "#6EB41B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTulip);
export default __webpack_public_path__ + "static/media/tulip.55a87372bc15e146a9dab424506f8ce8.svg";
export { ForwardRef as ReactComponent };